import styled from "@emotion/styled";

/**
 * Visually-hidden but present in the DOM. SSR-rendered HTML reaches AI crawlers
 * (GPTBot, ClaudeBot, PerplexityBot, Googlebot, etc.) and screen readers,
 * while sighted users see nothing. Standard accessibility "sr-only" pattern —
 * not cloaking because the same HTML is served to bots and humans.
 */
export const Wrapper = styled.section`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  gap: 32px;
`;

export const Lead = styled.div`
  h2 {
    font-size: 22px;
    line-height: 1.3;
    margin: 0 0 12px 0;
    color: #fff;
    font-weight: 700;

    @media (min-width: 768px) {
      font-size: 28px;
    }
  }

  p {
    font-size: 15px;
    line-height: 1.6;
    margin: 0;
    color: #c4c4c4;

    @media (min-width: 768px) {
      font-size: 17px;
    }
  }

  strong {
    color: #fff;
    font-weight: 600;
  }
`;

export const StatsGrid = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }

  li {
    background: #161616;
    border: 1px solid #232323;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .num {
    font-size: 24px;
    font-weight: 700;
    color: #fff;

    @media (min-width: 768px) {
      font-size: 30px;
    }
  }

  .label {
    font-size: 13px;
    color: #9a9a9a;
    line-height: 1.4;
  }
`;

export const FaqList = styled.div`
  display: grid;
  gap: 8px;

  h3 {
    font-size: 18px;
    margin: 0 0 8px 0;
    color: #fff;
    font-weight: 600;

    @media (min-width: 768px) {
      font-size: 22px;
    }
  }

  details {
    background: #161616;
    border: 1px solid #232323;
    border-radius: 10px;
    padding: 14px 16px;

    summary {
      cursor: pointer;
      font-weight: 600;
      color: #fff;
      font-size: 15px;
      list-style: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;

      &::-webkit-details-marker {
        display: none;
      }

      &::after {
        content: "+";
        color: #888;
        font-size: 20px;
        line-height: 1;
      }
    }

    &[open] summary::after {
      content: "−";
    }

    p {
      margin: 12px 0 0 0;
      font-size: 14px;
      line-height: 1.6;
      color: #c4c4c4;
    }
  }
`;
